import _ from "lodash";
import { FC, useEffect, useState } from "react";
import { Card, Progress } from "antd";

import Markdown from "markdown-to-jsx";
import { marked } from "marked";
import DOMPurify from "dompurify";

import { MarkdownConfig } from "constants/markdown";

marked.use({
  async: true,
  pedantic: false,
  gfm: true,
  breaks: true,
});

const PROGRESS_TIME_CONSTANT_MS = 8000;
const PROGRESS_TICK_MS = 200;

const FiabiliteSummary: FC = ({
  dataFiabiliteSummary,
  isFetchingFiabiliteSummary,
}: any) => {
  const [markdownText, setMarkdownText] = useState("");

  const [progress, setProgress] = useState(0);

  // The backend takes ~8s on average: simulate progress on an easing curve
  // (~86% at 8s) that never reaches 100% until the response arrives.
  useEffect(() => {
    if (!isFetchingFiabiliteSummary) {
      return;
    }
    const startedAt = Date.now();
    setProgress(0);
    const interval = setInterval(() => {
      const elapsed = Date.now() - startedAt;
      setProgress(Math.min(99, Math.round(99 * (1 - Math.exp(-elapsed / PROGRESS_TIME_CONSTANT_MS)))));
    }, PROGRESS_TICK_MS);
    return () => clearInterval(interval);
  }, [isFetchingFiabiliteSummary]);

  useEffect(() => {
    const parseMarkdownText = async () => {
      const details =
        _.get(dataFiabiliteSummary, "content") ||
        _.get(dataFiabiliteSummary, "reliability_details", "");
      if (!details) {
        setMarkdownText("");
        return;
      }
      const text = await marked.parse(details);
      setMarkdownText(DOMPurify.sanitize(text));
    };
    parseMarkdownText();
  }, [dataFiabiliteSummary]);

  if (isFetchingFiabiliteSummary) {
    return (
      <Card className="mb-3">
        <p className="text-[16px] mb-2">Analyse de la fiabilité en cours…</p>
        <Progress
          percent={progress}
          showInfo={false}
          strokeColor="#3b8686"
          status="active"
        />
      </Card>
    );
  }

  if (!markdownText) {
    return null;
  }

  return (
    <Card className="mb-3">
      <div className="energy-home__project-info__reliability-complement">
        <Markdown
          className="text-[16px]"
          options={{
            forceWrapper: true,
            wrapper: "div",
            overrides: MarkdownConfig,
          }}
        >
          {markdownText}
        </Markdown>
      </div>
    </Card>
  );
};

export default FiabiliteSummary;
